import { isSSR } from '@helpers';
import { snakeCase } from 'lodash';

if (!isSSR() && !window.requestIdleCallback) {
  window.requestIdleCallback = callback => {
    setTimeout(callback, 100);
  };
}

const actions = Object.freeze({
  OPEN_CONTROLS: 'open_myprice_inputs',
  PERSONALIZE_RATES: 'personalize_rates',
  FINISH_FETCHING: 'fetch_rates',
  SELECT_RATE: 'select_rate',
  LOAD_MORE_RATES: 'load_more_rates',
  ENABLE_PRODUCT_TYPE: 'enable_product_type',
  DISABLE_PRODUCT_TYPE: 'disable_product_type',
  OPEN_FAQ: 'open_faq',
  ERROR: 'myprice_error',
  VIEW_RACK_RATES: 'view_rack_rates',
  OPEN_BOOKING_MODAL: 'booking_open'
});

class Tracker {
  constructor() {
    this.track = this.track.bind(this);
    this.isDebug = false;
  }

  get actions() {
    return actions;
  }

  track(eventName, eventParams, eventCallback) {
    if (isSSR() || this.isDebug) {
      return;
    }

    eventParams ??= {};

    const {
      callback = eventCallback,
      timeout = 2000,
      minCallbackTimeout,
      ...customParams
    } = eventParams;

    if (!eventName) {
      console.error('Event name is required');
      return;
    }

    const gtag =
      window.gtag ||
      function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
      };

    const callbackWithTimeout = () => {
      let hasCalled = false;
      let hasReachedMinTimeout =
        isNaN(minCallbackTimeout) || minCallbackTimeout === 0;

      const fn = () => {
        if (callback && !hasCalled) {
          hasCalled = true;

          if (hasReachedMinTimeout) {
            callback();
          }
        }
      };

      setTimeout(fn, timeout);

      if (!hasReachedMinTimeout) {
        setTimeout(() => {
          hasReachedMinTimeout = true;

          if (hasCalled && callback) {
            callback();
          }
        }, minCallbackTimeout);
      }

      return fn;
    };

    requestIdleCallback(
      () => {
        const params = {
          event_callback: callbackWithTimeout(),
          event_timeout: timeout
        };

        Object.keys(customParams).forEach(key => {
          params[snakeCase(key)] = customParams[key];
        });

        gtag('event', eventName, params);
      },
      { timeout: 5000 }
    );
  }
}

const tracker = new Tracker();

export default tracker;
